import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPage as setPageAction } from "../../actions/advancedListActions";
import {
  handleChange as handleChangeAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../actions/handleChangeAction";

import map from "lodash/map";
import { getIleggelser } from "../../actions/ileggelserActions";
import { getIleggelsestyper } from "../../actions/ileggelsestyperActions";
import { getOvertredelserkoderIleggelser } from "../../actions/overtredelseskoderIleggelserActions";
import * as inputValidation from "../../utils/inputValidationUtils";

import { INITIAL_STATE as InnsynIleggelserFilterFormStateInitial } from "../../reducers/forms/InnsynIleggelserFilterFormReducer";
import { replaceWhitespacesWithEmptyStrings } from "../../utils/sanitizationUtils";
import { IsValidated } from "../../utils/validationUtils";
import InnsynIleggelserFilterForm from "./InnsynIleggelserFilterForm";

const rules = {
  ileggelsesnummer: "isPositiveInteger",
};

export default function InnsynIleggelserFilterContainer() {
  const dispatch = useDispatch();
  const ileggelser = useSelector((state) => state.ileggelser);
  const InnsynIleggelserFilterFormState = useSelector(
    (state) => state.forms.InnsynIleggelserFilterFormState,
  );
  const ileggelsestyper = useSelector((state) => state.ileggelsestyper);
  const overtredelseskoderIleggelser = useSelector(
    (state) => state.overtredelseskoderIleggelser,
  );

  const [shallGetIleggelserDueToHandleChangeToInitState, setShallGet] =
    useState(false);
  const [showSokSpinner, setShowSokSpinner] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getOvertredelserkoderIleggelser());
    dispatch(getIleggelsestyper());
  }, []);

  useEffect(() => {
    if (
      JSON.stringify(InnsynIleggelserFilterFormState) ===
        JSON.stringify(InnsynIleggelserFilterFormStateInitial) &&
      shallGetIleggelserDueToHandleChangeToInitState === true
    ) {
      setShallGet(false);
    }
  }, [
    InnsynIleggelserFilterFormState,
    shallGetIleggelserDueToHandleChangeToInitState,
  ]);

  // Dispatches a form field change — used by validate() and reset helpers
  const dispatchChange = (variableName, value) =>
    dispatch(
      handleChangeAction("INNSYN_ILEGGELSER_FILTER_FORM", variableName, value),
    );

  const handleChange = (e) => {
    dispatchChange(e.target.name, e.target.value);
  };

  const handleChangeToInitState = () => {
    dispatch(handleChangeToInitStateAction("INNSYN_ILEGGELSER_FILTER_FORM"));
    setShallGet(true);
  };

  const resetValidationErrorText = () => {
    dispatchChange("fraDatoValidationErrorText", null);
    dispatchChange("fraTidValidationErrorText", null);
    dispatchChange("tilDatoValidationErrorText", null);
    dispatchChange("tilTidValidationErrorText", null);
  };

  const validate = () => {
    const { isValid, validationError } = IsValidated(
      { ...InnsynIleggelserFilterFormState },
      rules,
    );
    dispatchChange(
      "validationError.ileggelsesnummer",
      validationError.ileggelsesnummer,
    );
    const fraDateTimeTilDateTimeValid =
      inputValidation.fraDateTimeTilDateTimeValidation(
        InnsynIleggelserFilterFormState,
        dispatchChange,
      );
    return isValid && fraDateTimeTilDateTimeValid;
  };

  const checkFiltersValue = () => {
    const filters = InnsynIleggelserFilterFormState;
    var hasValue = false;
    map(filters, (v) => {
      if (v !== null && v !== "") hasValue = true;
    });
    return hasValue;
  };

  const getFilters = () => {
    let {
      fraTid,
      tilTid,
      fraDatoValidationErrorText,
      fraTidValidationErrorText,
      tilDatoValidationErrorText,
      tilTidValidationErrorText,
      status,
      ...filter
    } = InnsynIleggelserFilterFormState;

    filter = {
      ...filter,
      fraDato: filter.fraDato && filter.fraDato.toISOString(),
      tilDato: filter.tilDato && filter.tilDato.toISOString(),
    };
    return filter;
  };

  const getIleggelserByFilters = () => {
    if (checkFiltersValue() && ileggelser.page && ileggelser.count) {
      setShowSokSpinner(true);
      const page = 1;
      dispatch(getIleggelser(getFilters(), page, ileggelser.count))
        .then(() => {
          setShowSokSpinner(false);
          dispatch(setPageAction("ileggelser", page));
        })
        .catch(() => setShowSokSpinner(false));
    }
  };

  const handleBlur = (e) => {
    if (e.target.name === "ileggelsesnummer") {
      dispatchChange(
        e.target.name,
        replaceWhitespacesWithEmptyStrings(e.target.value),
      );
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    resetValidationErrorText();
    if (validate()) {
      getIleggelserByFilters();
    }
  };

  return (
    <InnsynIleggelserFilterForm
      showSokSpinner={showSokSpinner}
      InnsynIleggelserFilterFormState={InnsynIleggelserFilterFormState}
      handleChange={handleChange}
      handleChangeToInitState={handleChangeToInitState}
      handleBlur={handleBlur}
      onSubmit={onSubmit}
      ileggelsestyper={ileggelsestyper}
      overtredelseskoderIleggelser={overtredelseskoderIleggelser}
    />
  );
}
